import TableAddRemove from './TableAddRemove';
import TableLanding from './TableLanding';
export { TableAddRemove, TableLanding };
